import axios from '../utils/axios'
//用量排名+用电曲线
export function GetRankChart(params) {
  return axios.post('/TemperatureMain/GetRankChart', params);
}
//实时统计+监测在线+预警
export function GetCurrentInfo(params) {
  return axios.post('/TemperatureMain/GetCurrentInfo', params);
}
//获取title
export function GetUserTitle(params) {
  return axios.get('/TemperatureMain/GetUserTitle');
}
//保存title
export function SaveUserTitle(params) {
  return axios.post('/TemperatureMain/SaveUserTitle', params);
}
//获取用电曲线
export function GetIndexCurveTotal(params) {
  return axios.get('/Main/GetIndexCurveTotal',{params});
}
//获取用水曲线
export function ChartUseWater(params) {
  return axios.post('/Monitor/ChartUseWater',params);
}
//获取用气曲线
export function ChartGasUse(params) {
  return axios.post('/Monitor/ChartGasUse',params);
}
//获取区域
export function getAllArea(params) {
  return axios.get('/System/GetAreaAll',{ params });
}
//获取最大剑锋评估
export function getMaxMultipleRateType(params) {
  return axios.get('/SetMeter/GetMaxMultipleRateType',{ params });
}
//模块切换
export function GetScreenModulesInfo(params) {
  return axios.post('/Screen/GetScreenModulesInfo', params);
} 
export function GetScreenModuleSetting(params) {
  return axios.post('/Screen/GetScreenModuleSetting', params);
} 
export function SaveScreenModuleSetting(params) {
  return axios.post('/Screen/SaveScreenModuleSetting', params);
}
//用能概括
export function GetUseEnergy(params) {
  return axios.post('/Screen/GetUseEnergy?areaID=' + params.areaID, params);
}
//用能排名
export function GetEnergyRank(params) {
  return axios.post('/Screen/GetEnergyRank', params);
}
//用能分析指标
export function GetEnergyTarget(params) {
  return axios.post('/Screen/GetEnergyTarget', params);
}
//告警接口
export function GetWarnEvent(params) {
  return axios.post('/Screen/GetWarnEvent', params);
}
//用电分析
export function GetChartDataJFPG(params) {
  return axios.get('/Main/GetChartDataJFPG', {params});
}
//设备监控+项目数据展示
export function GetMonitorPoint(params) {
  return axios.post('/Screen/GetMonitorPoint', params);
}
//复费率占比
export function SummaryDJDL(params) {
  return axios.post('/Screen/SummaryDJDL', params);
}
//项目信息
export function GetScreenProjectSetting(params) {
  return axios.post('/Screen/GetScreenProjectSetting', params);
}
//项目信息设置
export function SaveScreenProjectSetting(params) {
  return axios.post('/Screen/SaveScreenProjectSetting', params);
}
//模块配置设置
export function SaveScreenSetting(params) {
  return axios.post('/Screen/SaveScreenSetting', params);
}
//模块设置获取
export function GetScreenSettings(params) {
  return axios.post('/Screen/GetScreenSettings', params);
}
//获取支付二维码
export function WeChatPay(params) {
  return axios.get('/Screen/WeChatPay', { params });
}
//电费概览
export function getChartDFZL(params) {
  return axios.post('/ElecCharge/ChartDFZL', params);
}
//设置切换权限
export function GetPrivilegeAll(params) {
  return axios.get('/System/GetActionManageList', {params});
}
//用能节能分析
export function GetEnergyEfficient(params) {
  return axios.post('/Screen/GetEnergyEfficient', params);
}
//用能自动获取
export function GetAutoGetEnergy(params) {
  return axios.post('/Screen/GetAutoGetEnergy', params);
}
//碳排放
export function CalCarbonEmissions(params) {
  return axios.post('/Screen/CalCarbonEmissions', params);
}
//支付回调
export function WechatPaySuccess(params) {
  return axios.post('/Screen/WechatPaySuccess', params);
}
//改造节能分析
export function GetEnergyEfficientStatistics(params) {
  return axios.post('/Screen/GetEnergyEfficientStatistics', params);
}
//获取项目列表
export function GetProjectListByUser(params) {
  return axios.post('/System/GetProjectListByUser', params);
}
//切换项目
export function UpdateLastProject(params) {
  return axios.post('/System/UpdateLastProject', params);
}
// 用能概榄详情
export function GetUseEnergyDetail(params) {
  return axios.post('/Screen/GetUseEnergyDetail',  params);
}